/*doesnt relate to edit resume block*/
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress
} from "@mui/material";
import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";

const ResumeSectionDialog = ({
  open,
  onClose,
  groupedResumeProjects = [],
  selectedSectionId,
  selectedSectionTitle,
  editProject,
  refresh,
  setGroupedResumeProjects
}) => {
  const [formData, setFormData] = useState({
    resumeSectionDetailId: 0,
    title: "",
    role: "",
    company: "",
    url: ""
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  // Pre-fill form for edit mode
  useEffect(() => {
    if (open && editProject) {
      setFormData({
        resumeSectionDetailId: editProject.resumeSectionDetailId,
        title: editProject.title || "",
        role: editProject.role || "",
        company: editProject.company || "",
        url: editProject.url || ""
      });
    } else if (open && !editProject) {
      setFormData({
        resumeSectionDetailId: 0,
        title: "",
        role: "",
        company: "",
        url: ""
      });
    }
    if (!open) {
      setErrors({});
    }
  }, [open, editProject]);

  const validate = () => {
    const newErrors = {};
    if (!formData.title.trim()) newErrors.title = "Project Title is required";
    if (!formData.role.trim()) newErrors.role = "Role/Character is required";
    if (!formData.company.trim()) newErrors.company = "Director/Production is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchResumeSections = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const { data } = await api.get(
        ENDPOINTS.getResumeSections({ userId })
      );
      const grouped = data.reduce((acc, item) => {
        const { resumeSectionId, sectionHeading, ...detail } = item;
        if (!acc[resumeSectionId]) {
          acc[resumeSectionId] = { sectionHeading, projects: [] };
        }
        acc[resumeSectionId].projects.push(detail);
        return acc;
      }, {});
      setGroupedResumeProjects(grouped);
    } catch (err) {
      console.error("Failed to fetch resume sections:", err);
    }
  };

const handleDetailsSave = async () => {
  if (!selectedSectionId) {
    alert("No section selected—cannot save.");
    return;
  }
  if (!validate()) return;

  setSaving(true);
  const userId = localStorage.getItem("userId") || "";

  const payload = {
    resumeSectionDetailId: formData.resumeSectionDetailId || 0,
    resumeSectionId: selectedSectionId,
    title: formData.title.trim(),
    role: formData.role.trim(),
    company: formData.company.trim(),
    url: formData.url.trim(),
    userId,
    userBy: userId,
    sortOrder: 0,
    activeFlag: true,
  };

  try {
    //  Corrected endpoint
    const res = await api.post(
      ENDPOINTS.addOrUpdateResumeSectionDetails(),
      payload
    );

    const result = res.data;

    if (result.resumeSectionDetailId || result.success) {
      if (typeof refresh === "function") {
        await refresh();
      } else {
        await fetchResumeSections();
      }
      onClose();
    } else {
      alert("Failed to save section details");
    }
  } catch (err) {
    console.error("Error saving details:", err);
    alert(`An error occurred while saving: ${err.message}`);
  } finally {
    setSaving(false);
  }
};


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {editProject ? "Edit Project in:" : "Add Credit to:"}{" "}
        <Typography component="span" fontWeight="bold">
          {selectedSectionTitle || "Untitled Section"}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <TextField
  fullWidth
  label="Project Title"
  value={formData.title}
  onChange={(e) => {
    setFormData((p) => ({ ...p, title: e.target.value }));
    setErrors((p) => ({ ...p, title: undefined }));
  }}
  error={!!errors.title}
  helperText={errors.title}
  sx={{ mb: 2, mt: 1 }}
  disabled={saving}
/>

        <TextField
          fullWidth
          label="Role/Character"
          value={formData.role}
          onChange={(e) => {
            setFormData((p) => ({ ...p, role: e.target.value }));
            setErrors((p) => ({ ...p, role: undefined }));
          }}
          error={!!errors.role}
          helperText={errors.role}
          sx={{ mb: 2 }}
          disabled={saving}
        />

        <TextField
          fullWidth
          label="Director/Production"
          value={formData.company}
          onChange={(e) => {
            setFormData((p) => ({ ...p, company: e.target.value }));
            setErrors((p) => ({ ...p, company: undefined }));
          }}
          error={!!errors.company}
          helperText={errors.company}
          sx={{ mb: 2 }}
          disabled={saving}
        />

        <TextField
          fullWidth
          label="URL (optional)"
          value={formData.url}
          onChange={(e) => setFormData((p) => ({ ...p, url: e.target.value }))}
          sx={{ mb: 2 }}
          disabled={saving}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={handleDetailsSave}
          variant="contained"
          color="primary"
          disabled={!selectedSectionId || saving}
          startIcon={saving ? <CircularProgress size={16} /> : null}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResumeSectionDialog;